import {NgModule} from '@angular/core';
import {MenuComponent} from "./menu.component";
import {CommonModule} from "@angular/common";
import {RouterLink} from "@angular/router";

@NgModule({
  declarations: [
    MenuComponent
  ],
  exports: [
    MenuComponent
  ],
  imports: [
    CommonModule,
    RouterLink,
  ]
})
export class MenuModule {
}
